import { useAppStore } from '@/features/shared/app-store';
import { gtmSelectors } from '@/features/gtm/shared/state/gtm-selectors';

export const useCustomDataInitialized = () => useAppStore(gtmSelectors.customDataInitialized);
